module.exports = __webpack_public_path__ + "img/HERO-head-04-reachny.69e8e0f7.png";